'use client'

import { useRef, useState } from 'react'
import { LuPause, LuPlay } from 'react-icons/lu'
import { Box, Flex } from '@chakra-ui/react'
import { usePathname } from 'next/navigation'

import { trackVideoEnd, trackVideoStart } from 'app/components/shared/Analytics/segment'

import { VideoButton } from './styles'

const VideoPlayer = (): JSX.Element => {
  const pathname = usePathname()
  const videoRef = useRef<any>(null)

  const [isHovering, setIsHovering] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)

  const handlePlayback = () => {
    const isVideoPlaying =
      videoRef.current.currentTime > 0 &&
      !videoRef.current.paused &&
      !videoRef.current.ended &&
      videoRef.current.readyState > 2

    if (isVideoPlaying) {
      setIsPlaying(false)
      videoRef.current.pause()
      trackVideoEnd('how-does-it-work.mp4', pathname ?? '')
    } else {
      setIsPlaying(true)
      videoRef.current.play()
      trackVideoStart('how-does-it-work.mp4', pathname ?? '')
    }
  }

  return (
    <Flex
      marginBottom={{ base: '72px', lg: '160px' }}
      marginTop={{ base: '28px', lg: '80px' }}
      position="relative"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onClick={handlePlayback}
      cursor="pointer"
      justifyContent="center"
      alignItems="center"
    >
      <VideoButton hidden={isPlaying && !isHovering}>
        {isPlaying ? <LuPause size={42} fill="black" /> : <LuPlay size={42} fill="black" />}
      </VideoButton>

      <Box width={{ md: '90%' }}>
        <video ref={videoRef} poster="/how-does-it-work-thumbnail.webp" preload="none">
          <source src="/how-does-it-work.mp4" type="video/mp4" />
          <picture>
            <source srcSet="/how-does-it-work-thumbnail.webp" type="image/webp" />
            <source srcSet="/how-does-it-work-thumbnail.png" type="image/png" />
            <img loading="lazy" src="/how-does-it-work-thumbnail.png" alt="How does it work?" />
          </picture>
        </video>
      </Box>
    </Flex>
  )
}

export default VideoPlayer
